import React, { Fragment, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { Box, Button, Chip, Divider, Typography } from "@mui/material";
import {
  ChevronRightRounded,
  KeyboardArrowUpRounded,
} from "@mui/icons-material";
import { GradientIconAccent } from "../../../../../../components/GradientIcon";
import { useThemeSettings } from "../../../../../../theme/ThemeSettingsProvider";

const useStyles = makeStyles()((theme) => ({
  card: {
    width: "100%",
    maxHeight: 481,
    overflow: "auto",
    padding: 16,
    border: "1px solid #E3F2FD",
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    boxShadow: "0 0 12px 1px rgba(191, 191, 191, 0.16)",
  },
  countChip: {
    borderRadius: 4,
    background:
      theme.palette.mode === "dark" ? theme.palette.background.light : "#EEE",
    fontWeight: 500,
  },
  fileTag: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    paddingTop: 8,
    paddingBottom: 8,
    cursor: "pointer",
    borderRadius: 8,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  gradientText: {
    background: theme.palette.accentGradient,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

function Tags({ tags }) {
  const { mode } = useThemeSettings();
  const isDarkMode = mode === "dark";
  const { classes } = useStyles();
  const [showAll, setShowAll] = useState(false);
  const tagNames = Object.keys(tags);
  const visibleTagNames = showAll ? tagNames : tagNames.slice(0, 8);
  return (
    <Box className={classes.card}>
      <Box display={"flex"} alignItems={"center"} gap={1} mb={1}>
        <Typography variant="body2" color="text.secondary">
          File Tags
        </Typography>
        <Chip
          size="small"
          label={Object.keys(tags).length}
          className={classes.countChip}
        />
      </Box>
      <Box>
        {visibleTagNames.map((tag, index) => {
          return (
            <Fragment key={tag}>
              <Box className={classes.fileTag}>
                <Typography
                  fontWeight={500}
                  textOverflow={"ellipsis"}
                  overflow={"hidden"}
                  whiteSpace={"nowrap"}>
                  {tag}
                </Typography>
                <Box display={"flex"} alignItems={"center"} gap={0.5}>
                  <Typography>{tags[tag]}</Typography>
                  <Typography>files</Typography>
                  <ChevronRightRounded sx={{ fontSize: 16 }} />
                </Box>
              </Box>
              {index !== visibleTagNames.length - 1 && (
                <Divider sx={{ my: 0.5 }} />
              )}
            </Fragment>
          );
        })}
        {tagNames.length > 8 && (
          <Box display={"flex"} justifyContent={"flex-end"}>
            <Button
              size="small"
              variant="text"
              color="primary"
              sx={{ textTransform: "none" }}
              endIcon={
                isDarkMode ? (
                  showAll ? (
                    <KeyboardArrowUpRounded
                      sx={{ color: (theme) => theme.palette.text.primary }}
                    />
                  ) : (
                    <ChevronRightRounded
                      sx={{ color: (theme) => theme.palette.text.primary }}
                    />
                  )
                ) : (
                  <GradientIconAccent
                    Icon={
                      showAll ? KeyboardArrowUpRounded : ChevronRightRounded
                    }
                  />
                )
              }
              onClick={() => setShowAll((prev) => !prev)}>
              <span className={classes.gradientText}>
                {showAll ? "View less" : `View All ${tagNames.length} Tags`}
              </span>
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default Tags;
